export default __webpack_public_path__ + "static/sobczyk-abece388261974da5cd8e6587cd0af5d.jpg";